// 🔧 vendor_step.js
// ✅ Purpose: Pipeline step for the LGV Vendor Engine
// ✅ Features:
// - Executes the Vendor Engine when Vendors are selected
// - Integrates with the shared DemoContext
// - Returns standardized pipeline results
// - Keeps pipeline orchestration independent of engine implementation
// - Fully block-commented for clarity and future devs

import { runVendorEngine } from "../../engines/vendors";

export const createVendorStep = () => ({
  id: "vendor_builder",

  name: "Vendor Builder",

  label: "Vendor Builder",

  run: async (demoContext) => {
    console.log("🏪 Vendor Pipeline Step started.");

    const result = await runVendorEngine({
      demoContext,
    });

    console.log("✅ Vendor Pipeline Step completed.", {
      result,
    });

    return result;
  },
});